import { Row } from 'react-table';
import { IraUsersResponse } from 'services/requests';
import Table from 'components/Table';
import { AVALIABLE_ROWS_PER_PAGE } from 'components/Table/Table.constants';
import TableFooter from 'components/Table/TableFooter';
import {
  columns,
  IraUsersTableSign,
  MapData,
} from '../../IraUsersTable/IraUsersTable.columns';

type Props = {
  iraUsersData?: IraUsersResponse;
  items?: MapData;
  onIraUserClick: (row: Row<IraUsersTableSign>) => void;
};

const RenderTable = ({
  iraUsersData,
  items,
  onIraUserClick,
}: Props): JSX.Element | null => {
  if (!iraUsersData?.context || !items || (items && items?.length === 0)) return null;

  return (
    <Table<IraUsersTableSign> columns={columns} data={items} onRowClick={onIraUserClick}>
      <TableFooter
        pages={iraUsersData.context.pages}
        totalRows={iraUsersData.context.totalRows}
        availableRowsPerPage={AVALIABLE_ROWS_PER_PAGE}
      />
    </Table>
  );
};

export default RenderTable;
